import * as React from 'react'
import { Button, Descriptions, PageHeader, Tabs } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router'

import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import container from '../../wires/Bootstrapper'

import { ClienteModel } from '../../models/ClienteModels'
import { UtenteModel } from '../../models/UtenteModels'
import { ClienteParams } from './ClienteParams'
import { IClienteAdminService } from '../../services/ClienteAdminService'

import { StresstestList } from '../stresstest/StresstestList'
import { TabUtenti } from './TabUtenti'
import { Stresstest } from '../stresstest/Stresstest'
import { TabRaccoltaDati } from './TabRaccoltaDati'
import { TabDashboard } from './TabDashboard'
import { TabConfigFatture } from './TabConfigFatture'
import { TabConfigCC } from './TabConfigCC'

import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../TelemetryService'
import { ILicenzeService } from '../../services/LicenzeService'
import moment from 'moment'

const { TabPane } = Tabs;

class ClienteState extends ClienteModel {
    Utenti: Array<UtenteModel>
    ActiveTab: string = '1'
    StatoLicenza: string
    ScadenzaLicenza: Date
}

export class PageClienteComp extends React.Component<RouteComponentProps<ClienteParams>, ClienteState> {

    service: IClienteAdminService
    serviceLicenza: ILicenzeService

    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.CLIENTE_ADMIN_SERVICE)
        this.serviceLicenza = container.get(SERVICE_IDENTIFIER.LICENZE_SERVICE);
        this.state = new ClienteState()
    }

    componentDidMount() {
        this.loadPage()
        this.setDefaultTab()
    }

    setDefaultTab = () => {
        const url = window.location.href
        if (url.includes('StressTest') === true)
            this.setState({ ActiveTab: '2' })
        if (url.includes('RaccoltaDati') === true)
            this.setState({ ActiveTab: '3' })
        if (url.includes('Dashboard') === true)
            this.setState({ ActiveTab: '4' })
        if (url.includes('ConfigFatture') === true)
            this.setState({ ActiveTab: '5' })
        if (url.includes('ConfigCC') === true)
            this.setState({ ActiveTab: '6' })
    }

    loadPage = async () => {
        let resp = await this.service.GetById(this.props.match.params.id)
        if (resp.IsValid)
            this.setState(resp)

        // TODO: Caricamento utenti per cliente
    }

    buy = () => {
        this.serviceLicenza.CompraLicenza(this.props.match.params.id).then(it => {
            if (it.IsValid) {
                debugger
                window.location.href = it.UrlPagamento
            }
        })
    }

    onClienteEditClick = () => {
        this.props.history.push(`/Cliente/Modifica/${this.props.match.params.id}`)
    }

    onTabChange = (key: string) => {
        let path = `/Cliente/Scheda/${this.props.match.params.id}`
        switch (key) {
            case '2':
                path = `/Cliente/Scheda/${this.props.match.params.id}/StressTest/Lista`
                break
            case '3':
                path = `/Cliente/Scheda/${this.props.match.params.id}/RaccoltaDati`
                break
            case '4':
                path = `/Cliente/Scheda/${this.props.match.params.id}/Dashboard`
                break
            case '5':
                path = `/Cliente/Scheda/${this.props.match.params.id}/ConfigFatture`
                break
            case '6':
                path = `/Cliente/Scheda/${this.props.match.params.id}/ConfigCC`
                break
        }

        this.props.history.push(path)
    }

    render() {
        return (
            <>
                <PageHeader title={this.state.Descrizione} onBack={() => this.props.history.push("/Clienti")} extra={[
                    <Button type="primary" key="edit-customer" icon={<EditOutlined />} onClick={() => this.onClienteEditClick()}>Modifica</Button>,
                    <Button type="primary" key="buy-license" icon={<EditOutlined />} onClick={() => this.buy()}
                        disabled={this.state.ScadenzaLicenza!=undefined } >Compra Licenza</Button>
                ]}>
                    <Descriptions size="small" column={2}>
                        <Descriptions.Item label="Email">
                            <a target="_blank" href={`mailto:${this.state.Email}`}>{this.state.Email}</a>
                        </Descriptions.Item>
                        <Descriptions.Item label="Telefono">
                            <a target="_blank" href={`tel:${this.state.Telefono}`}>{this.state.Telefono}</a>
                        </Descriptions.Item>
                        <Descriptions.Item label="Licenza">
                            <span >{this.state.StatoLicenza} &nbsp; &nbsp; &nbsp; scade il: {this.state.ScadenzaLicenza!= undefined ? moment(this.state.ScadenzaLicenza).format('L') : ""}</span>
                        </Descriptions.Item>
                    </Descriptions>
                    <br />
                    <Tabs defaultActiveKey="1" activeKey={this.state.ActiveTab} onChange={(key) => this.onTabChange(key)}>
                        <TabPane tab="Utenti" key="1" />
                        <TabPane tab="Stress test" key="2" />
                        <TabPane tab="Raccolta Dati" key="3" />
                        <TabPane tab="Dashboard" key="4" />
                        <TabPane tab="Config Fatturazione" key="5" />
                        <TabPane tab="Config CC" key="6" />
                    </Tabs>
                    <Switch>
                        <Route exact path={`${this.props.match.url}`} render={() => <TabUtenti clienteId={this.props.match.params.id} utenti={this.state.Utenti} />} />
                        <Route path={`${this.props.match.url}/StressTest/Lista`} render={() => <StresstestList clienteId={this.props.match.params.id} />} />
                        <Route path={`${this.props.match.url}/StressTest/Dettaglio/:id`} render={() => <Stresstest />} />
                        <Route path={`${this.props.match.url}/RaccoltaDati`} render={() => <TabRaccoltaDati clienteId={this.props.match.params.id} />} />
                        <Route path={`${this.props.match.url}/Dashboard`} render={() => <TabDashboard clienteId={this.props.match.params.id} />} />
                        <Route path={`${this.props.match.url}/ConfigFatture`} render={() => <TabConfigFatture clienteId={this.props.match.params.id} />} />
                        <Route path={`${this.props.match.url}/ConfigCC`} render={() => <TabConfigCC clienteId={this.props.match.params.id} />} />
                    </Switch>
                </PageHeader>
            </>
        )
    }
}

export const PageCliente = withRouter(withAITracking(ai.reactPlugin, PageClienteComp,"PageCliente")); 
